import client from './client';

export const getMonitoringLocations = tenant =>
  client.get('/terrain/v1/monitor/locations/', {
    params: {
      tenant_id: tenant
    }
  });

export const getOverallMonitoring = cluster =>
  client.get(`/terrain/v2/monitor/overall/${cluster}/`);

export const getTerrestrialMonitoring = cluster =>
  client.get(`/terrain/v2/monitor/${cluster}/`);

export const getHydrologicalMonitoring = cluster =>
  client.get(`/hydrology/v2/monitor/${cluster}/`);

export const getEnvironmentologyMonitoring = cluster =>
  client.get(`/environment/v2/monitor/${cluster}/`);

export const getSoilMonitoring = cluster =>
  client.get(`/pedology/v2/monitor/${cluster}/`);
